import { useQuery } from "react-query";
import { getStandard } from "../../../../../actions/Utilities/Standard";

export default function useGetStandard() {
  return useQuery("GetStandard", getStandard, {
    refetchOnWindowFocus: false,
  });
}
